/**
 * 是否有双重角色：教师身份，且有孩子或者是管理员
 */
import store from '@/store/';

export default (el) => {
    const hasBoth = 1 === store.getters.userInfo.typeall;
    el.style.display =  hasBoth ? '' :'none'
}
